module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.onepagers.length > 0) ? _c('div', [_c('document-container', {
    attrs: {
      "body": [],
      "footer": [],
      "documentType": "emissions-cover",
      "orientation": "landscape"
    },
    scopedSlots: _vm._u([{
      key: "raw-header",
      fn: function() {
        return [_c('header', {
          staticClass: "raw-header"
        }, [_c('img', {
          staticClass: "logo",
          attrs: {
            "src": _vm.logo,
            "alt": ""
          }
        })])]
      },
      proxy: true
    }], null, false, 1002179492)
  }, [_vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h1', [_vm._v("PRIVATE BANKING ZERTIFIKATE")]), _vm._v(" "), _c('h2', [_vm._v("EMISSIONSKALENDER")])])])]), _vm._v(" "), _c('div', {
    staticClass: "onepager-container emissions",
    class: _vm.environment
  }, _vm._l((_vm.onepagers), function(onepager) {
    return _c('onepager', {
      key: onepager.type,
      attrs: {
        "environment": _vm.environment,
        "logo": _vm.logo,
        "multiRowPath": onepager.multiRowPath,
        "products": onepager.products,
        "tableConfig": onepager.tableConfig,
        "template": _vm.getTemplateManager(onepager.template),
        "type": onepager.type
      }
    })
  }), 1), _vm._v(" "), _c('document-container', {
    attrs: {
      "body": [],
      "footer": [],
      "header": [{
        'type': 'Pagetitle',
        'position': 'header',

        'title': 'Haftungsausschluß',
      }],
      "logo": _vm.logo,
      "documentType": "onepager",
      "orientation": "landscape"
    }
  }, [_c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('p', [_vm._v("\n        Die in diesem Zeichnungskalender enthaltenen Informationen richten sich ausschließlich an Kreditinstitute, Finanzdienstleistungsinstitute und sonstige professionelle Marktteilnehmer und dienen ausschließlich Informations- und Vertriebsunterstützungszwecken.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Die Informationen stellen weder eine Anlageberatung noch eine Anlageempfehlung oder Finanzanalyse im Sinne von MiFID II, des Wertpapierhandelsgesetzes (WpHG) oder der Marktmißbrauchsrichtlinie (MAR) dar und sind weder als Angebot noch als Aufforderung zum Kauf oder Verkauf von Finanzinstrumenten zu verstehen.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Eine Prüfung der Geeignetheit oder Angemessenheit für den jeweiligen Endkunden erfolgt nicht. Diese liegt ausschließlich in der Verantwortung des jeweils beratenden bzw. vertreibenden Instituts. Maßgeblich für eine Anlageentscheidung sind ausschließlich die jeweiligen Emissionsunterlagen, insbesondere die Endgültigen Bedingungen, der Basisprospekt sowie das Basisinformationsblatt (KID). Die dargestellten Informationen berücksichtigen keine individuellen Anlageziele, die finanzielle Situation oder die Kenntnisse und Erfahrungen von Anlegern.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Eine Haftung für die Vollständigkeit und Richtigkeit der Angaben wird, soweit gesetzlich zulässig, nicht übernommen.\n      ")])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-644b9af1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emissions/Emissions.vue
// module id = 693
// module chunks = 0